import { render, staticRenderFns } from "./InvoiceFormInput.vue?vue&type=template&id=e855d9e4&scoped=true&"
import script from "./InvoiceFormInput.vue?vue&type=script&lang=ts&"
export * from "./InvoiceFormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e855d9e4",
  null
  
)

export default component.exports